import GoogleIcon from 'components/core/icons/google.svg'
import Image from 'components/core/image'
import React from 'react'

const Google = (): React.ReactElement => {
    return <Image src={GoogleIcon.src} height={24} width={24} />
}

export default Google
